<payee-popup
  [onCancel]="cancel"
  [onSubmit]="submit"
>
  <ng-template #payeePopupTitleTemplate>
    <h1>Szeretnéd, hogy a bankszámla innentől a DNB-ből frissüljön?</h1>
  </ng-template>
  <ng-template #payeePopupDescriptionTemplate></ng-template>
</payee-popup>
